<!-- Loader global -->
<div *ngIf="loading" class="loader-overlay">
  <div class="spinner"></div>
</div>

<app-top-bar *ngIf="mostrarTopBar()"></app-top-bar>
<!-- <app-digital-card-launcher *ngIf="mostrarTopBar()"></app-digital-card-launcher> -->

<!-- Layout con sidebar -->
<div
  class="app-layout"
  *ngIf="mostrarTopBar()"
  [class.sidebar-oculto]="sidebarOculto"
>
  <button
    *ngIf="!sidebarOculto"
    type="button"
    class="mobile-sidebar-backdrop"
    (click)="onSidebarToggle(false)"
    aria-label="Cerrar aplicaciones"
  ></button>

  <app-sidebar
    (menuToggle)="onSidebarToggle($event)"
    [menuVisible]="!sidebarOculto"
  ></app-sidebar>

  <main class="page-content">
    <section class="window-shell">
      <header class="window-titlebar">
        <div class="title-left"></div>

        <div class="title-right">
          <span class="win-icon">—</span>
        </div>
      </header>

      <div class="window-body">
        <router-outlet></router-outlet>
      </div>
    </section>
  </main>
</div>

<!-- Layout sin sidebar -->
<main class="auth-layout" *ngIf="!mostrarTopBar()">
  <router-outlet></router-outlet>
</main>

<!-- El copiloto permanece disponible en todas las páginas autenticadas. -->
<app-copilot-chat *ngIf="mostrarTopBar()"></app-copilot-chat>

<!-- Avatar operativo global: visible en todos los módulos autenticados y PWA. -->
<app-avatar-assistant *ngIf="mostrarTopBar()"></app-avatar-assistant>